import Isotope from 'isotope-layout';

export default el => {
    const init = () => {
        const iso = new Isotope(el, {
            itemSelector: '[data-item]',
            masonry: {
                horizontalOrder: true
            }
        });
        iso.arrange();
    };

    const destroy = () => {};

    return {
        init,
        destroy
    };
};




// WEBPACK FOOTER //
// ./src/js/components/IsotopeList.js